<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="7.5" stroke="currentColor" stroke-width="1.8" />
        <path d="M15.5 15.5l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        <path
            d="M7 8.2h6M7.8 10.5h4.4M9 12.8h2"
            stroke="currentColor"
            stroke-width="1.3"
            stroke-linecap="round"
        />
    </svg>
</template>